// extracted by mini-css-extract-plugin
export const globalWrapper = "layout-module--globalWrapper--3jtnh";
export const globalHeader = "layout-module--globalHeader--3b0u5";
export const mainHeading = "layout-module--mainHeading--UF_QS";
export const headerLinkHome = "layout-module--headerLinkHome--4bB8T";
export const footerLogo = "layout-module--footerLogo--1GtG_";
export const logo = "layout-module--logo--10qPK";